import { defineMessages } from 'react-intl';

export default defineMessages({
    creatingYourOfferingMessage: {
        id: 'rewrite.eu.directives.MultiQuoteView.Please wait while we create your offering...',
        defaultMessage: 'Please wait while we create your offering...'
    },
    policyLevelCoverages: {
        id: 'rewrite.eu.directives.MultiQuoteView.Policy Level Coverages',
        defaultMessage: 'Policy Level Coverages'
    },
    ratingYourPolicyMessage: {
        id: 'rewrite.eu.directives.MultiQuoteView.Please wait while we rate your policy...',
        defaultMessage: 'Please wait while we rate your policy...'
    },
});
